import { render, staticRenderFns } from "./OrgRelStaff.vue?vue&type=template&id=0e54a3a5"
import script from "./OrgRelStaff.vue?vue&type=script&lang=js"
export * from "./OrgRelStaff.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports